// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__ESkhT","fadeIn":"Footer_fadeIn__-ky2W"};